/* RESPONSIBLE TEAM: team-tickets-1 */
import type SetTicketCustomState from 'embercom/models/operator/visual-builder/step/set-ticket-custom-state';
import StepConfig, { type StepConfigParams } from '../step';

export default class SetTicketStateConfiguration extends StepConfig {
  declare step: SetTicketCustomState;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/set-ticket-custom-state',
      ...params,
    });
  }
}
